import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Getter, State, Action, Mutation } from 'vuex-class'
import Footer from '@/components/footer/footer'
import Header from '@/components/header/header'

@Component({
  components: {
    Footer,
    Header
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name !== 'checkout') {
      this.PAYMENT_LINK_STATUS(null)
    }
    next()
  }
})
export default class PaymentLinkConfirmation extends Vue {
  @Getter getUser: any
  @Getter getPaymentLinkStatus: any
  @Getter getCountry: any
  @Getter getPseOrder: any

  @Action action_getPaymentLinkStatus: any
  @Action action_setPseStatus: any
  // @Action action_getBankPse: any;
  @Mutation PAYMENT_LINK_STATUS: any
  payment_link_transaction_id = ''
  interval = null

  async mounted() {
    // this.action_getBankPse();
    const id = this.$route.query.id
    this.action_setPseStatus({ id: id })
    if (id) {
      this.payment_link_transaction_id = id as any;
      this.PAYMENT_LINK_STATUS(null)
      const link_res = await this.action_getPaymentLinkStatus(id)

      if (this.getPaymentLinkStatus.status === 'PENDING') {
        this._interval()
      }
    }
  }

  get getPrice() {
    const price = this.getPaymentLinkStatus && Object.keys(this.getPaymentLinkStatus).length > 0 && this.getPaymentLinkStatus.amount_in_cents / 100
    return price && this.$currency.format(price, { code: this.getCountry.currency })
  }

  get getBtnTxt() {
    const code = this.getPaymentLinkStatus.status
    return code === 'DECLINED' || code == 'ERROR' ? '' : 'Ver resumen del pedido'
  }

  getBankName(code) {
    return '';
    // return this.getPseBanks.find((x) => { return x.bankCode == code }).bankName
  }

  _interval() {
    this.interval = this.interval = setInterval(async () => {
      await this.action_getPaymentLinkStatus(this.payment_link_transaction_id)
      if (this.getPaymentLinkStatus.status !== 'PENDING') {
        clearInterval(this.interval)
      }
    }, 20000);
  }

  _print() {
    window.print()
  }

  getStatus(val) {
    if (val == 'APPROVED') {
      return 'Aprobada'
    } else if (val == 'DECLINED') {
      return 'Rechazada'
    } else if (val == 'VOIDED') {
      return 'Cancelada'
    } else if (val == 'ERROR') {
      return 'con error'
    }
  }

  _send() {
    // const code = this.getPaymentLinkStatus.data.cod_respuesta
    // if (code === 2 || code == 4) {
    //   this.$router.push({ name: 'checkout' })
    // } else {
    this.$router.push({ name: 'history_orders' })
    // }
  }

  _openChat() {
    // open_chat(`${this.getUser.first_name} ${this.getUser.last_name}`, this.getUser.email, this.getUser.cellphone, this.getUser.first_order_date,  `Hola, tengo un problema con mi pedido con id ${this.getPseOrder.id}, necesito ayuda con mi método de pago, gracias`);
    // @ts-ignore
    // $crisp.push(["do", "chat:open"])
    // @ts-ignore
    // $crisp.push(["set", "message:text", [`Hola!. Estoy intentando hacer un pedido pero el cobro no fue efectuado me puedes ayudar. Orden #${this.getPseOrder.order_id}, Valor ${this.getPriceWaiting}.`]])
  }



}
